import { ComponentsEnum } from '../../types';
import INavigationItem from '../../types/INavigationItem';

const NavigationCheckBusiness: Array<INavigationItem> = [
  { title: 'Größe Gewerbefläche', id: ComponentsEnum.COMMERCIAL_SIZE },
  { title: 'PLZ', id: ComponentsEnum.POST_CODE },
  { title: 'Rechtsschutzversicherung', id: ComponentsEnum.LEGAL },
  { title: 'Prüfpaket', id: ComponentsEnum.PACKAGE },
  { title: 'Registrierung', id: ComponentsEnum.REGISTER },
  { title: 'Ihre Hinweise', id: ComponentsEnum.COMMENTS },
  { title: 'Nebenkostenabrechnung', id: ComponentsEnum.STATEMENT },
  { title: 'Mietvertrag', id: ComponentsEnum.CONTRACT },
  { title: 'Fragen', id: ComponentsEnum.ASK },
  { title: 'Expertenprüfung', id: ComponentsEnum.EXPERT_CHECK },
  { title: 'Prüfergebnis', id: ComponentsEnum.TEST_RESULT },
];

export default NavigationCheckBusiness;
